import { Component, NgModule, OnInit, Input, ChangeDetectorRef, Inject, PLATFORM_ID, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Page } from '../shared/navigation/pages.model';
import { SharedModule } from '../shared/shared.module';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';
import { isPlatformBrowser } from '@angular/common';

@Component({
    templateUrl: 'lazy3.component.html',
    styleUrls: ['lazy3.component.scss'],
})

export class Lazy3Component implements OnInit, AfterViewInit, OnDestroy {
    public cdn = environment.cdn;
    public pageName = environment.name;
    public pageTitle: string;
    public pageContent: string;
    public gallery: any;
    public children: Page[] = [];
    public path_register = '/';
    public path_offer_1 = '/';
    public path_offer_2 = '/';
    public path_offer_3 = '/';
    public path_contact = '/';
    
    private stage:any;
    private slides:any;
    private links:any;
    private slideID = 0;

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private ngZone: NgZone, private router: Router, private cdr: ChangeDetectorRef) {}

    ngOnInit() { 
        if (isPlatformBrowser(this.platformId)) {
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollToPlugin);
        }
        this.path_register = this.router.config.find(x => +x?.data.id === -982).path;
        this.path_offer_1 = this.router.config.find(r =>  +r?.data.id === 63)?.data.path || '/';
        this.path_offer_2 = this.router.config.find(r =>  +r?.data.id === 64)?.data.path || '/';
        this.path_offer_3 = this.router.config.find(r =>  +r?.data.id === 65)?.data.path || '/';
        this.path_contact = this.router.config.find(x => x?.data.module === 'ContactModule')?.data.path || '/';
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.ngZone.runOutsideAngular(() => {
                // this.initHeader();
                const select = e => document.querySelector(e);
                const selectAll = e => document.querySelectorAll(e);
                this.stage = select('.stage');
                this.slides = selectAll(".slide");
                this.links = selectAll(".scroll-link-href");

                gsap.set(this.stage, { autoAlpha: 1 });
                // this.initIntro();
                this.initLinks();
                this.initSlides();
                this.initParallax();
            });
        }
    }

    initIntro() {
    
        // animate the intro elements into place
        
        let tl = gsap.timeline({delay: 1.2});
        
        tl.from('.logo-wrap', {
            // x: 100,
            y: 400,
            opacity: 0,
            ease: 'power4',
            duration: 3
        })
        .from('.intro-content-txt', {
            x: 100,
            opacity: 0,
            ease: 'power4',
            duration: 3
        }, 0.7)
        .from('.intro-img-1', {
            // x: -50,
            y: 50,
            opacity: 0,
            ease: 'power2',
            duration: 6
        }, 1)
        .from('.intro-img-2', {
            // x: 50,
            y: -50,
            opacity: 0,
            ease: 'power2',
            duration: 6
        }, 1)
        .from('.scroll-link-intro', {
            y: 200,
            duration: 1,
            ease: "power4"
        }, 0.4);
        
        // set up scrollTrigger animation for the when the intro scrolls out
        
        let stl = gsap.timeline({
            scrollTrigger: {
                trigger: '.intro',
                scrub: 1,
                start: "35% bottom",
                end: "bottom top"
            }
        });
        
        stl.to('.logo-wrap', {
            x: 400,
            ease: 'power4.in',
            duration: 3,
            
        })
        .to('.intro-content-txt', {
            y: 400,
            ease: 'power4.in',
            duration: 3,
        }, 0);
    }

    private initSlides() {
    
        // Animation of each slide scrolling into view
        
        this.slides.forEach((slide, i) => {   
            
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    scrub: 1,
                    start: "0% 50%",
                    end: "50% 50%", 
                    // markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            });
     
            tl.from(slide.querySelectorAll('.slide-content-title'), {
                y: "+=5vh",
                ease: "power2",
                duration: 2.5,
            })
            .from(slide.querySelectorAll('.line-inner'), {
                x: -100,
                opacity: 0,
                duration: 2,
                ease: "power2",
                stagger: 0.1
            }, 0)
            .from(slide.querySelectorAll('.content-txt'), {
                y: 100,
                //y: 50,
                opacity: 0,
                duration: 2,
                ease: "power2"
            }, 0.4)
            .from(slide.querySelectorAll('.flat-button'), {
                y: 100,
                opacity: 0,
                duration: 2,
                ease: "power2"
            }, 0.3)
            .from(slide.querySelectorAll('.scroll-link'), {
                y: 100,
                duration: 2,
                ease: "power4"
            }, 0.4)
            // .to(slide.querySelectorAll('.slide__scroll-line'), {
            //     scaleY: 0.6,
            //     transformOrigin: "bottom left",
            //     duration: 2.5, 
            //     ease: "elastic(1,0.5)"
            // }, 1.4)

            
        });
    }
    
    private initParallax() {      
        this.slides.forEach((slide, i) => {
            let imageWrappers = slide.querySelectorAll('.image-wrap');
            
            gsap.fromTo(imageWrappers, {
                y: "-30vh"
            },{
                y: "30vh",
                scrollTrigger: {
                    trigger: slide,
                    scrub: true,
                    start: "top bottom",
                    // snap: {
                    //     snapTo: 0.5,
                    //     duration: 1,
                    //     ease: 'power4.inOut'
                    // }
                },
                ease: 'none'
            })
        });
    }

    private initLinks() {
    
        // ScrollToPlugin links
        
        this.links.forEach((link, index, e) => {     
            link.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, {
                    duration: 2, 
                    scrollTo:{
                        y: (link.getAttribute("href") == '#slide0' ? 0 : link.getAttribute("href"))
                    },
                    ease: "power2.inOut"
                });
                this.slideID++;
            });
            
        });
    }

    private scrollTop() {
        gsap.to(window, {
            duration: 2, 
            scrollTo: {
                y: 0
            },
            ease: "power2.inOut"
        });
    }
    
    ngOnDestroy(): void {
        if (this.links) {
            this.links.forEach((link) => {     
                link.removeAllListeners('click');
            });
        }
        ScrollTrigger.getAll().forEach(t => t.kill());
        gsap.globalTimeline.getChildren().forEach(child => child.kill());
    }
    
}

@NgModule({
    declarations: [Lazy3Component],
    imports: [SharedModule]
})
class Lazy3Module { }